import InvoiceType from "$routes/patient/[:patientId]/_lib/invoices/invoice-type";
import { Box, makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import { INSURER } from "../../InsurerAccordion/formConstants";
import Header from "./Header";
import InsuranceDetails from "./InsuranceDetails";
import InvoiceTable from "./InvoiceTable";
import PatientDetails from "./PatientDetails";

const useStyles = makeStyles({
  printWrapper: {
    margin: "5mm",
  },
  box: {
    margin: "0",
    position: "relative",
    height: "94%",
  },
});

const InsurerInvoice = ({ invoice, insurer }) => {
  const classes = useStyles();
  return (
    <div className={classes.printWrapper} key={insurer.name}>
      <div style={{ pageBreakBefore: "always" }}>
        <Box className={classes.box}>
          {insurer?.type === INSURER ? (
            <InsuranceDetails insurer={insurer} invoice={invoice} />
          ) : (
            <>
              <Header invoice={invoice} />
              <PatientDetails invoice={invoice} />
            </>
          )}
          <InvoiceTable insurer={insurer} invoice={invoice} />
        </Box>
      </div>
    </div>
  );
};

InsurerInvoice.propTypes = {
  invoice: InvoiceType.isRequired,
  insurer: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
};

export default InsurerInvoice;
